import { createRequestActions } from '../utils';
import * as ToxProfileChapterTypes from './toxProfileChapterTypes';

export const listToxProfilChapter = createRequestActions(ToxProfileChapterTypes.TOX_PROFILE_CHAPTER_LIST);
